/**
 * Initializes all of the widgets, spinning off onload events from each of them
 */
$(function() {
    var $ = jQuery;
    window.search_form = new SearchForm("quick-search-form");
    window.search_list = new SearchList();
    window.search_calendar = new SearchCalendar("calendar-section");
    window.search_map = new SearchMap("map_canvas_search");

    /* mobile nav */
    $("#search-view-calendar").on("click", function() {
        $("#display").val("calendar").trigger("change");
    });

    $("#search-view-list").on("click", function() {
        $("#display").val("list").trigger("change");
    });

    $("#search-view-map").on("click", function() {
        $("#display").val("map").trigger("change");
    });

    checkForEllipses();
    renderCarousel();
});

function renderCarousel() {
  // adding carousel to listings
  $('.mod-listing').each(function(){
      $(this).data('initSlide', $(this).html());
      $(this).find('.flexslider-listing').flexslider({
          controlNav: false,
          slideshow: false,
          animationSpeed: 200,
          keyboard: false,

            // lazy load carousel images
            start: function(slider) { // Fires when the slider loads the first slide
                var slide_count = slider.count - 2;

                $(slider).find('img.lazy:eq(0), img.lazy:eq(' + slide_count + ')').each(function() {
                    var src = $(this).attr('data-src');
                    $(this).attr('src', src).removeAttr('data-src');
                });
            },
            before: function(slider) { // Fires asynchronously with each slider animation
                var slides     = slider.slides,
                    next       = slider.animatingTo,
                    $slide     = $(slides[next]),
                    $img       = $slide.find('img[data-src]'),
                    nxt_slide  = next,
                    prev_slide = next - 2;

                $slide.parent().find('img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')').each(function() {
                    var src = $(this).attr('data-src');
                    $(this).removeAttr('data-src').attr('src', src);
                    $(this).parent().addClass('flex-slide');
                });
            }
        });
    });
}

/**
 * Toggle split and calendar view when the button is pressed
 */
$(function() {
    var once = true;

    // Desktops
    $("#search-view-toggle").on("click", function() {
        if($("#display").val() !== "calendar") {
            $("#display").val("calendar").trigger("change");
            $("#map-resizing").addClass("no-map");
            once = false;
        } else {
            $("#display").val("list").trigger("change");
            if(once){
                $("#display").val("list").trigger("triggerMarkerBounds");
                once = false;
            }

            // Fixes safari animating the listings when switching from the calendar
            noTrans();
        }
    });

    // Mobile triggering a marker bounds when clicking on the map
    $("#search-view-map").on("click", function() {
        if(once){
            $("#display").trigger("triggerMarkerBounds");
            once = false;
        }
    });
});

/**
 * Saves SearchWhenMoved checkbox state
 */
$(function() {
    var mapSearchWhenMoved;
    $("#redoSearchWhenMoved").on('click', function(){
        if (storageAvailable('localStorage')) {
            if($("#redoSearchWhenMoved :checked").length === 1){
                window.sessionStorage.setItem("mapSearchWhenMoved", 'true');
            } else {
                window.sessionStorage.setItem("mapSearchWhenMoved", 'false');
            }
        }
    });

    if (storageAvailable('localStorage')) {
        mapSearchWhenMoved = window.sessionStorage.getItem("mapSearchWhenMoved");
    }

    if(mapSearchWhenMoved === 'false'){
        $("#redoSearchWhenMoved input").removeAttr("checked");
    }
});

/**
 * Map more/less map button trigger
 */
$(function() {
    var mapWidth;
    if (storageAvailable('localStorage')) {
        mapWidth = window.sessionStorage.getItem("mapWidth");

        // Setting the more-map if we have it from previous session
        // Also setting no transition since this is a fresh page load
        if(mapWidth === 'more-map') {
            moreMap();
            noTrans();
        } else {
            lessMap();
        }
    }

    /**
     * The more/less-map toggler
     */
    $("#map-width-toggle").on('click', function() {
        if (storageAvailable('localStorage')) {
            mapWidth = window.sessionStorage.getItem("mapWidth");
        }

        if (mapWidth === 'more-map') {
            lessMap();
            mapWidth = 'less-map';
        } else {
            moreMap();
            mapWidth = 'more-map';
        }
    });
});

/**
 * Adding and removing animations
 */
function noTrans() {
    $("#map-section, #search-page-main").addClass("transition-none");
    setTimeout(function(){
        $("#map-section, #search-page-main").removeClass("transition-none");
    }, 500);
}

/**
 * Makes the map wider
 */
function moreMap() {
    if (storageAvailable('localStorage')) {
        window.sessionStorage.setItem("mapWidth", 'more-map');
    }
    $(".more-map-btn").hide();
    $(".less-map-btn").show();
    $("#map-resizing").removeClass("less-map no-map").addClass("more-map").trigger("searchFormResizeBegin");
    $("#map-resizing").one("transitionend", function() {
        $("#map-resizing").trigger("searchFormResizeEnd");
        checkForEllipses();
    });
}

/**
 * Makes the map less wide
 */
function lessMap() {
    if (storageAvailable('localStorage')) {
        window.sessionStorage.setItem("mapWidth", 'less-map');
    }
    $(".more-map-btn").show();
    $(".less-map-btn").hide();
    $("#map-resizing").removeClass("more-map no-map").addClass("less-map").trigger("searchFormResizeBegin");
    $("#map-resizing").one("transitionend", function() {
        $("#map-resizing").trigger("searchFormResizeEnd");
        checkForEllipses();
    });
}

/**
 * Local Storage checker
 */
function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
    } catch (e) {
        return false;
    }
}

/**
 * Setting refresh Map results trigger
 */
$(function() {
    $("#triggerRefreshButton").on("click", function() {
        $("#triggerRefreshButton").trigger("triggerMapRefresh");
    });
});

/**
 * Check and add classes when window is resized
 */
$(function() {
    window.onresize = function(){
        $("#map-resizing").removeClass("less-map");
    };
});

/**
 * Related destinations show more
 */
$(function() {
    $(".related-dest-show-more").on("click", function() {
        $(".related-destinations-section ul").addClass("open");
        $(".related-dest-show-more").hide();
        $(".gray-fade-line").hide();
    });
});

/**
 * Only display "show more" if last item in destination list has ellipses
 */
function checkForEllipses() {
    if ($('.related-destinations-section ul').length > 0) {
        if ($('.related-destinations-section ul')[0].scrollWidth >  $('.related-destinations-section ul').innerWidth()) {
            $(".related-dest-show-more").show();
            $(".gray-fade-line").show();
        }
        else {
            $(".related-dest-show-more").hide();
            $(".gray-fade-line").hide();
        }
    }
}

$(window).resize(function() {
    checkForEllipses();
});

$(document).ready(function() {
    targetBlank();
});

window.renderCarousel = renderCarousel;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/searchResults.js
// module id = 12
// module chunks = 0